import { useFormik } from "formik";
import React from "react";
import { useDispatch } from "react-redux";
import { categoryActions } from "reducers/categoryReducer";
import { Button, Form, Header, Segment } from "semantic-ui-react";
import Alerts from "utilities/Alerts";
import http from "utilities/http";

function AddCategory({ name: newCategoryName }) {
	const dispatch = useDispatch();
	const submitAddCategory = async (values, handlers) => {
		try {
			const response = await http({
				method: "POST",
				url: "/categories/add",
				data: {
					...values,
				},
			});

			const { message, id } = response.data;

			Alerts.success(message);

			handlers.resetForm();

			dispatch(
				categoryActions.addCategory({
					...values,
					_id: id,
				})
			);
		} catch (ex) {
			Alerts.httpException(ex);
		}
	};
	const addCategoryForm = useFormik({
		initialValues: {
			name: newCategoryName ?? "",
		},
		onSubmit: submitAddCategory,
	});
	return (
		<Form onSubmit={addCategoryForm.handleSubmit}>
			<Header as="h2">Add New Category</Header>
			<Segment loading={addCategoryForm.isSubmitting}>
				<Form.Input
					name="name"
					label="New Category Name"
					placeholder="**Must be uniquie**"
					value={addCategoryForm.values.name}
					onChange={addCategoryForm.handleChange}
					onBlur={addCategoryForm.handleBlur}
				/>
				<Button positive type="submit">
					Add Category
				</Button>
			</Segment>
		</Form>
	);
}

export default AddCategory;
